import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, onBeforeMount, reactive } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useRouter } from "vue-router";
import Pagination from "@/components/Pagination/index.vue";
import "swiper/swiper.scss";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  //name: "Information",
  components: {
    Head: Head,
    Pagination: Pagination
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter();
    var baseUrl = process.env.VUE_APP_BASE_URL; // onBeforeRouteUpdate((to) => {
    //   if(to.fullPath.indexOf('my')!=-1){
    //     Data.myshow = false
    //   }else{
    //     Data.myshow = true
    //   }
    // }) 
    // 获取个人资料

    var Data = reactive({
      searchContent: "",
      list: [],
      total: 0,
      value1: '',
      search: {
        startTime: "",
        endTime: "",
        pageIndex: 1,
        pageSize: 10,
        fieldName: ""
      }
    });

    var changPage = function changPage(val) {
      Data.search.pageIndex = val;
    };

    function getDetail() {
      return _getDetail.apply(this, arguments);
    } //详情


    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$globalProperti2, data, total;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["FieldMyList"](Data.search);

              case 2:
                _yield$globalProperti2 = _context3.sent;
                data = _yield$globalProperti2.data;
                total = _yield$globalProperti2.total;
                Data.list = data;
                Data.total = total;
                Data.list.forEach(function (item) {
                  if (new Date(item.endTime) < new Date() || item.status == 2) {
                    item.color = '#e8e8e8';
                  } else {
                    item.color = '#c62423';
                  }
                });

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getDetail.apply(this, arguments);
    }

    var detail = function detail(id) {
      router.push({
        name: "FieldDetail",
        query: {
          fieldId: id,
          my: 1
        }
      });
    };

    var handleClick = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var _yield$globalProperti, code;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(val.color == '#c62423')) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["Fieldcancel"](val.recordId);

              case 3:
                _yield$globalProperti = _context.sent;
                code = _yield$globalProperti.code;

                if (code == 0) {
                  ElMessage.success("取消预约成功");
                  getDetail();
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleClick(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    function searchList() {
      return _searchList.apply(this, arguments);
    }

    function _searchList() {
      _searchList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getDetail();

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _searchList.apply(this, arguments);
    }

    function myappointment() {
      router.back();
    }

    onBeforeMount( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getDetail();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    return {
      getDetail: getDetail,
      Data: Data,
      detail: detail,
      handleClick: handleClick,
      searchList: searchList,
      changPage: changPage,
      baseUrl: baseUrl,
      myappointment: myappointment
    };
  }
});